import { render, staticRenderFns } from "./DetailedStatsWidget.vue?vue&type=template&id=90f22bda&scoped=true&"
import script from "./DetailedStatsWidget.vue?vue&type=script&lang=js&"
export * from "./DetailedStatsWidget.vue?vue&type=script&lang=js&"
import style0 from "./DetailedStatsWidget.vue?vue&type=style&index=0&id=90f22bda&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90f22bda",
  null
  
)

export default component.exports